import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useDevice } from '@/hooks/useDevice';
export const copyText = function (str) {
  return new Promise(function (resolve, reject) {
    const input = document.createElement('input');
    input.value = str;
    document.body.appendChild(input);
    input.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      document.body.removeChild(input);
      resolve(true);
    } else {
      reject(new Error('Copy failed'));
    }
  });
};

// 自定义数据上报事件
export const customEvent = function (type, params) {
  window.staticFn.customEvent(type, _objectSpread({}, params));
};
export const handleOpenUrl = function (url, isMobile) {
  const {
    isWeixin
  } = useDevice();
  const isAliPay = (url === null || url === void 0 ? void 0 : url.includes('punchout_form')) && (url === null || url === void 0 ? void 0 : url.includes('alipay'));

  // 国内PC微信支付需要在订单确认弹窗展示二维码,
  if (!isMobile && (url !== null && url !== void 0 && url.includes('https://open.weixin.qq.com') || url !== null && url !== void 0 && url.includes('cnp=qr') || url !== null && url !== void 0 && url.includes('weixin://')) && !isWeixin.value) {
    return;
  }
  if (isAliPay) {
    const $div = document.createElement('div');
    $div.innerHTML = url;
    document.body.appendChild($div);
    if (!isMobile) {
      $div.querySelector('form').target = '_blank';
    }
    $div.querySelector('form').submit();
    return;
  }
  if (isMobile) {
    window.location.href = url;
  } else {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
    link.click();
    link.addEventListener('click', function () {
      link.remove();
    });
  }
};

/* 判断客户端 */
export const judgeClient = function () {
  const {
    isIOS,
    isAndroid,
    isWeixin
  } = useDevice();
  console.log(`是否是微信：${isWeixin.value}`); // true,false
  console.log(`是否是Android：${isAndroid.value}`); // true,false
  console.log(`是否是iOS：${isIOS()}`);
  // 微信内浏览器环境
  if (isWeixin.value) {
    return 2;
  }
  if (isAndroid.value) {
    return 0;
  }
  if (isIOS()) {
    return 1;
  }
  return 2;
};

// 防抖函数
export const debounce = function (fn, delay = 200) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      return fn(...args);
    }, delay);
  };
};